'use strict';/* global define */define('modules/quick-feedback/services/praise-participants/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["API_ENDPOINT", "$resource"];
function factory(API_ENDPOINT,$resource){return $resource(API_ENDPOINT+'praises/:id/participants',{id:'@id'});}module.exports=factory;});
